import { render } from "./AllPhysicians.vue?vue&type=template&id=531695fe"
import script from "./AllPhysicians.vue?vue&type=script&lang=js"
export * from "./AllPhysicians.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/physicians/AllPhysicians.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "531695fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('531695fe', __exports__)) {
    console.log('reload')
    api.reload('531695fe', __exports__)
  }
  
  module.hot.accept("./AllPhysicians.vue?vue&type=template&id=531695fe", () => {
    console.log('re-render')
    api.rerender('531695fe', render)
  })

}


export default __exports__